<template>
  <div class="user">
    <div class="photo">
      <img src="static/img/faces/face-1.jpg"/>
    </div>
    <div class="info">
      <a href="#">
        <span>{{ name }}</span>
      </a>
      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    computed: {
      name() {
        return this.$store.getters['security/name']
      }
    },
    data() {
      return {
        isClosed: true,
        fullName: null
      }
    }
  }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
</style>
